export const knowledgeBaseTypes = {
  GET_KNOWLEDGE_BASE_DATA: 'GET_KNOWLEDGE_BASE_DATA',
  GET_KNOWLEDGE_BASE_DATA_SUCCESS: 'GET_KNOWLEDGE_BASE_DATA_SUCCESS',
  GET_KNOWLEDGE_BASE_DATA_FAILURE: 'GET_KNOWLEDGE_BASE_DATA_FAILURE',

  PUT_KNOWLEDGE_BASE_DATA: 'PUT_KNOWLEDGE_BASE_DATA',
  PUT_KNOWLEDGE_BASE_DATA_SUCCESS: 'PUT_KNOWLEDGE_BASE_DATA_SUCCESS',
  PUT_KNOWLEDGE_BASE_DATA_FAILURE: 'PUT_KNOWLEDGE_BASE_DATA_FAILURE',
};
